import { render, staticRenderFns } from "./RehinAcigiBelgesiHazirlanmasiTalepEvrakForm.vue?vue&type=template&id=3b3ada40"
import script from "./RehinAcigiBelgesiHazirlanmasiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./RehinAcigiBelgesiHazirlanmasiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports